import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';

const styles = {
  iconBig: {
    padding: '0px',
    fontSize: 30
  },
  bigButton: {
    display: 'inline-flex',
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 0,
    padding: '8px',
    justifyContent: 'start',
    color: '#2196f3'
  },
  bigButtonClose: {
    display: 'inline-flex',
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 0,
    padding: '8px',
    justifyContent: 'center',
    color: '#2196f3'
  },
  text: {
    fontSize: 12,
    fontWeight: 600,
    marginLeft: 15,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  number: {
    width: '15px',
    height: '15px',
    paddingLeft: '0px',
    marginTop: '-4px',
    marginLeft: '5px',
    backgroundColor: 'red',
    color: 'white',
    borderRadius: '30px',
    fontSize: 11,
    lineHeight: '1.5',
    right: '10px',
    fontWeight: 500
  },

  currentMenu: {
    backgroundColor: '#2196f3',
    color: '#ffffff',

    '&:hover, &:focus': {
      backgroundColor: '#2196f3',
      color: '#ffffff'
    },
    '& div': {
      color: '#ffffff'
    }
  },
  disableBtn: {
    backgroundColor: '#E0E0E0',
    color: 'rgba(0, 0, 0, 0.3)',
    pointerEvents: 'none',
    '& div': {
      color: 'rgba(0, 0, 0, 0.3)'
    }
  }
};

const enhance = compose(pure);

const button = enhance(
  ({
    classes,
    classStyle,
    label,
    numberCount,
    onClickAction,
    open,
    currentRoute,
    disabled
  }) => {
    const currentMenu = currentRoute === window.location.pathname;
    let noticeNumber;
    if (numberCount && numberCount !== '') {
      noticeNumber = <div className={classes.number}>{numberCount}</div>;
    } else {
      noticeNumber = '';
    }
    console.log(numberCount);
    return (
      <Button
        className={classNames(
          open ? classes.bigButton : classes.bigButtonClose,
          currentMenu ? classes.currentMenu : '',
          disabled && classes.disableBtn
        )}
        onClick={() => {
          onClickAction();
        }}
      >
        <i
          className={`${classStyle} ${classes.iconBig} ${
            currentMenu ? 'selected-icon' : ''
          } ${disabled ? 'disable-icon' : ''}`}
        />
        {open && <div className={classes.text}>{label}</div>}
        {noticeNumber}
      </Button>
    );
  }
);

export default withStyles(styles)(button);
